import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import { useSettingsChipTone } from '~/components/AiSearchChips/settingsChipTone';
import { collectionOperatorLabel, isExistenceCollectionPredicate, summarizeCollectionPredicate } from './CollectionConditionChip.utils';
export const CollectionConditionChip = (param)=>{
    let { testId, fieldLabel, nounLabel, quantifier, predicate, grammar, onToggleQuantifier, onRemove } = param;
    const tone = useSettingsChipTone();
    const texts = grammar.texts;
    const summary = summarizeCollectionPredicate(predicate, texts);
    const isExistence = isExistenceCollectionPredicate(predicate);
    const operatorLabel = isExistence ? quantifier === 'none' ? texts.collectionExistsOperatorHasNo() : undefined : collectionOperatorLabel(quantifier, texts);
    return /*#__PURE__*/ _jsx(FilterChip, {
        testId: testId,
        fieldLabel: fieldLabel,
        operator: operatorLabel == null ? undefined : {
            label: operatorLabel,
            onToggle: onToggleQuantifier,
            biName: grammar.bi.toggle
        },
        valueLabel: summary === '' ? nounLabel : summary,
        onRemove: onRemove,
        removeBiName: grammar.bi.remove,
        tone: tone
    });
};
